import { Cell } from "@/playground/components/DevHome/table/pages/conversation_center/components/Cell/Cell";
import { HeaderSimple } from "@/playground/components/DevHome/table/pages/conversation_center/components/HeaderSimple/HeaderSimple";
import type { ColumnType } from "../columns.decl";

export const dateConfig: ColumnType = {
  id: "time",
  label: <HeaderSimple label="time" />,
  renderer: (_, value) => <Cell date={value} />,
};
